// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1aAoK","buttons":"SendReceipts_buttons__30uA1","email":"SendReceipts_email__3AP6P","bookApptTitle":"SendReceipts_bookApptTitle__1LHcF"};